<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="1" :tab="$t('tab.exchangeBoxList')" style="margin-top: -14px">
        <exchangeBoxList ref="exchangeBoxList" @dblclick="dblclick" />
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('tab.exchangeBox')" forceRender style="margin-top: -14px">
        <exchangeBox ref="exchangeBox" />
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <a-button :disabled="query" type="primary" @click="getData">{{ $t('button.query') }}</a-button>
        <a-button :disabled="exchangeBox" type="primary" @click="changeBox">{{ $t('button.exchangeBox') }}</a-button>
      </a-space>
    </a-tabs>
  </a-layout>
</template>
<script>
  import ExchangeBoxList from '@/views/outbound/outbound_exchange/ExchangeBoxList.vue'
  import ExchangeBox from '@/views/outbound/outbound_exchange/ExchangeBox.vue'

  export default {
    name: 'OutBoundBoxExchange',
    components: { ExchangeBox, ExchangeBoxList },
    data() {
      return {
        activeKey: '2',
        supervisionCode: false,
        printTag: false,
        exchangeBox: false,
        query: true
      }
    },
    watch: {
      activeKey: {
        handler(newVal) {
          if (newVal === '1') {
            this.supervisionCode = true
            this.printTag = true
            this.exchangeBox = true
            this.query = false
          } else if (newVal === '2') {
            this.supervisionCode = false
            this.printTag = false
            this.exchangeBox = false
            this.query = true
          }
        }
      }
    },
    mounted() {

    },
    methods: {
      SupervisionCodeCollection() {

      },
      print() {
      },
      changeBox() {
        this.$refs.exchangeBox.quantityConfirm()
      },
      getData() {
        this.$refs.exchangeBoxList.getData()
      },
      dblclick(e) {
        this.activeKey = '2'
        this.$refs.exchangeBox.scanBarcode = e.containerNo
        this.$refs.exchangeBox.getData()
      }
    }
  }
</script>